import { SignInIdentifier } from '@logto/schemas';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import SecondaryPageLayout from '@/Layout/SecondaryPageLayout';
import UserInteractionContext from '@/Providers/UserInteractionContextProvider/UserInteractionContext';
import EavierMobileLoginLayout from '@/components/EavierMobileLoginLayout';
import useEavierAuthTheme from '@/hooks/use-eavier-auth-theme';
import { useSieMethods } from '@/hooks/use-sie';
import ErrorPage from '@/pages/ErrorPage';
import { formatPhoneNumberWithCountryCallingCode } from '@/utils/country-code';
import { identifierInputDescriptionMap } from '@/utils/form';

import PasswordForm from './PasswordForm';

const SignInPassword = () => {
  const { t } = useTranslation();
  const { signInMethods } = useSieMethods();
  const isEavierAuthTheme = useEavierAuthTheme();

  const { identifierInputValue } = useContext(UserInteractionContext);

  if (!identifierInputValue) {
    return <ErrorPage title="error.invalid_session" />;
  }

  const { type, value } = identifierInputValue;

  const methodSetting = signInMethods.find((method) => method.identifier === type);

  // Sign-in method not enabled
  if (!methodSetting?.password) {
    return <ErrorPage />;
  }

  const descriptionProps = {
    method: t(identifierInputDescriptionMap[methodSetting.identifier]),
    value:
      methodSetting.identifier === SignInIdentifier.Phone
        ? formatPhoneNumberWithCountryCallingCode(value)
        : value,
  };
  const form = (
    <PasswordForm
      autoFocus
      identifier={methodSetting.identifier}
      value={value}
      isVerificationCodeEnabled={methodSetting.verificationCode}
    />
  );

  return isEavierAuthTheme ? (
    <EavierMobileLoginLayout
      pageMeta={{ titleKey: 'description.enter_password' }}
      subtitle={t('description.enter_password_for', descriptionProps)}
    >
      {form}
    </EavierMobileLoginLayout>
  ) : (
    <SecondaryPageLayout
      title="description.enter_password"
      description="description.enter_password_for"
      descriptionProps={descriptionProps}
    >
      {form}
    </SecondaryPageLayout>
  );
};

export default SignInPassword;
